import Vue from "vue";
import Router from "vue-router";
import index from "@/view/Index";
import ListVue from "@/view/ListVue";
import ListVue3 from "@/view/ListVue3";
import ListVuePatches from "@/view/ListVuePatches";
import ListReact from "@/view/ListReact";
import ListJquery from "@/view/ListJquery";
import ListZepto from "@/view/ListZepto";
import ListElementUi from "@/view/ListElementUi";
import ListMintUi from "@/view/ListMintUi";
import ListBootstrap from "@/view/ListBootstrap";
import ListIview from "@/view/ListIview";
import Lodash from "@/view/ListLodash";
import Moment from "@/view/ListMoment";
import Normalize from "@/view/ListNormalize";
import Echarts from "@/view/ListEcharts";
import Vuex from "@/view/ListVuex";
import VueRouter from "@/view/ListVueRouter";
import VueFilter from "@/view/ListVueFilter";
import Axios from "@/view/ListAxios";
import Swiper from "@/view/ListSwiper";
import Groceries from "@/view/ListGroceries";
import Gc from "@/view/ListGrapeCity";
import Baohe from "@/view/ListBaohe";
import cloudPrint from "@/view/ListCloudPrint";

import Zcat from "@/view/ListZcat";
import CKEditor4 from "@/view/ListCKEditor4";
import Three from "@/view/ListThree";
import Additional from "@/view/ListAdditional";
import Zui from "@/view/ListZui";
import ZuiPatches from "@/view/ListZuiPatches";
import ZuiScrew from "@/view/ListZuiScrew";
import ZuiQK from "@/view/ListZuiQK";
import Working from "@/view/ListWorking";
import JqueryQrcode from "@/view/ListJqueryQrcode";
import ZGP from "@/view/ListZGP";
import Zpush from "@/view/ListZpush";
import Vant from "@/view/ListVant";
import ListZtoAd from "@/view/ListZtoAd";
import ListWebrtc from "@/view/ListWebrtc";
import ListClickstream from "@/view/ListClickstream";
import ListPrintSdk from "@/view/ListPrintSdk";
import ListPhoneSDK from "@/view/ListPhoneSDK";
import Day from "@/view/ListDay";
import ListMicro from "@/view/ListMicro";
import ListUs from "@/view/ListUs";
import ListXlsx from "@/view/ListXlsx";
import ListElement from "@/view/ListElement";
import ListMapvgl from "@/view/ListMapvgl";
import ListInvoice from "@/view/ListInvoice";
import ListLowcodeRenderer from "@/view/ListLowcodeRenderer";
import ListVconsole from "@/view/ListVconsole";
import ListZztSDK from "@/view/ListZztSDK";
import ListRegistSdk from "@/view/ListRegistSdk";
import ListZtoMap from "@/view/ListZtoMap";
import ListMzui from "@/view/ListMzui";
import ListHtml2canvas from "@/view/ListHtml2canvas";
import ListVueofficeDocs from "@/view/ListVueofficeDocs";
import ListVueofficePdf from "@/view/ListVueofficePdf";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: index
    },
    {
      path: "/vue",
      name: "vue",
      component: ListVue
    },
    {
      path: "/vue3",
      name: "vue3",
      component: ListVue3
    },
    {
      path: "/vue-patches",
      name: "vue-patches",
      component: ListVuePatches
    },
    {
      path: "/react",
      name: "react",
      component: ListReact
    },
    {
      path: "/jquery",
      name: "jquery",
      component: ListJquery
    },
    {
      path: "/zepto",
      name: "zepto",
      component: ListZepto
    },
    {
      path: "/elementUi",
      name: "elementUi",
      component: ListElementUi
    },
    {
      path: "/mintUi",
      name: "mintUi",
      component: ListMintUi
    },
    {
      path: "/bootstrap",
      name: "bootstrap",
      component: ListBootstrap
    },
    {
      path: "/iview",
      name: "iview",
      component: ListIview
    },
    {
      path: "/lodash",
      name: "lodash",
      component: Lodash
    },
    {
      path: "/moment",
      name: "moment",
      component: Moment
    },
    {
      path: "/normalize",
      name: "normalize",
      component: Normalize
    },
    {
      path: "/echarts",
      name: "echarts",
      component: Echarts
    },
    {
      path: "/vuex",
      name: "vuex",
      component: Vuex
    },
    {
      path: "/vue-router",
      name: "vue-router",
      component: VueRouter
    },
    {
      path: "/vue-filter",
      name: "vue-filter",
      component: VueFilter
    },
    {
      path: "/axios",
      name: "axios",
      component: Axios
    },
    {
      path: "/swiper",
      name: "swiper",
      component: Swiper
    },
    {
      path: "/gc",
      name: "gc",
      component: Gc
    },
    {
      path: "/baohe",
      name: "baohe",
      component: Baohe
    },
    {
      path: "/cloudPrint",
      name: "cloudPrint",
      component: cloudPrint
    },
    {
      path: "/zcat",
      name: "zcat",
      component: Zcat
    },
    {
      path: "/ckeditor4",
      name: "ckeditor4",
      component: CKEditor4
    },
    {
      path: "/groceries",
      name: "groceries",
      component: Groceries
    },
    {
      path: "/three",
      name: "three",
      component: Three
    },
    {
      path: "/additional",
      name: "additional",
      component: Additional
    },
    {
      path: "/zui",
      name: "zui",
      component: Zui
    },
    {
      path: "/zui-patches",
      name: "zui-patches",
      component: ZuiPatches
    },
    {
      path: "/zui-screw",
      name: "zui-screw",
      component: ZuiScrew
    },
    {
      path: "/zui-qk",
      name: "zui-qk",
      component: ZuiQK
    },
    {
      path: "/working",
      name: "working",
      component: Working
    },
    {
      path: "/jquery.qrcode",
      name: "JqueryQrcode",
      component: JqueryQrcode
    },
    {
      path: "/zgp",
      name: "ZGP",
      component: ZGP
    },
    {
      path: "/zpush",
      name: "zpush",
      component: Zpush
    },
    {
      path: "/vant",
      name: "vant",
      component: Vant
    },
    {
      path: "/zto-ad",
      name: "zto-ad",
      component: ListZtoAd
    },
    {
      path: "/zto-webrtc",
      name: "zto-webrtc",
      component: ListWebrtc
    },
    {
      path: "/clickstream",
      name: "clickstream",
      component: ListClickstream
    },
    {
      path: "/printSdk",
      name: "printSdk",
      component: ListPrintSdk
    },
    {
      path: "/phone-sdk",
      name: "phone-sdk",
      component: ListPhoneSDK
    },
    {
      path: "/day",
      name: "day",
      component: Day
    },
    {
      path: "/micro",
      name: "micro",
      component: ListMicro
    },
    {
      path: "/zto-us",
      name: "zto-us",
      component: ListUs
    },
    {
      path: "/xlsx",
      name: "xlsx",
      component: ListXlsx
    },
    {
      path: "/element",
      name: "element",
      component: ListElement
    },
    {
      path: "/mapvgl",
      name: "mapvgl",
      component: ListMapvgl
    },
    {
      path: "/invoice-sdk",
      name: "invoice-sdk",
      component: ListInvoice
    },
    {
      path: "/lowcode-renderer",
      name: "lowcode-renderer",
      component: ListLowcodeRenderer
    },
    {
      path: "/vconsole",
      name: "vconsole",
      component: ListVconsole
    },
    {
      path: "/zzt-sdk",
      name: "/zzt-sdk",
      component: ListZztSDK
    },
    {
      path: "/regist-sdk",
      name: "/regist-sdk",
      component: ListRegistSdk
    },
    {
      path: "/zto-map",
      name: "/zto-map",
      component: ListZtoMap
    },
    {
      path: "/mzui",
      name: "/mzui",
      component: ListMzui
    },
    {
      path: "/html2canvas",
      name: "/html2canvas",
      component: ListHtml2canvas
    },
    {
      path: "/vue-office-docx",
      name: "/vue-office-docx",
      component: ListVueofficeDocs
    },
    {
      path: "/vue-office-pdf",
      name: "/vue-office-pdf",
      component: ListVueofficePdf
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js